import i18next from 'i18next'
import { upperFirst } from 'lodash-es'
import API from 'state/API'
import { newDate } from 'utils'
import Model from './Model'

export default class Invoice extends Model {

	/** @type Date */ created_at
	/** @type string */ offline_paid_status
	/** @type string */ payment
	/** @type string */ invoice_link_guid
	/** @type number */ total_amount_due
	/** @type boolean */ sent
	/** Already translated payment status
	 * @type string */ paid_status
	/** Payable status based on paid_status
	 * @type boolean */ payable

	/**
	 * @param created_at
	 * @param paid_status {string}
	 * @param attrs
	 */
	constructor({ created_at, paid_status, ...attrs }) {
		super(attrs)
		this.created_at = newDate(null, created_at)

		this.paid_status = paid_status.toLowerCase()|>upperFirst
		switch (this.paid_status) {
			case 'Authorized and captured': //merges online and offline payment statuses into simpler, jargon-free expression
				this.paid_status = i18next.t('Paid')
				this.payable		 = false
				break
			case 'Pending': //more urgent wording for clients to pay up :))
				this.paid_status = i18next.t('Not paid')
				this.payable		= true
				break
			default:
				// t('Voided / refunded')
				// 'Authorized - not captured': will be removed at sc30613, it's a carry-over from customer payments
				this.paid_status = i18next.t(this.paid_status.replace('/',' / '))
				this.payable		 = false
		}
	}

	get url() {
		return {
			pdf: API.getUrl(`invoice/guid-${this.invoice_link_guid}/pdf`),
			pay: `${process.env.REACT_APP_BASE_URL}/pay?guid=${this.invoice_link_guid}`,
		}
	}

}
